import { api } from '../lib/api';
import type { AuditLogActor, AuditLogPage } from '../types/api';

export interface AuditLogFilters {
  actorId?: string;
  action?: string;
  entityType?: string;
  from?: string;
  to?: string;
  page?: number;
  pageSize?: number;
}

// §23: MSP-Admin-only search over the full audit log.
export async function listAuditLogs(filters: AuditLogFilters): Promise<AuditLogPage> {
  const params = new URLSearchParams();
  if (filters.actorId) params.set('actorId', filters.actorId);
  if (filters.action) params.set('action', filters.action);
  if (filters.entityType) params.set('entityType', filters.entityType);
  if (filters.from) params.set('from', filters.from);
  if (filters.to) params.set('to', filters.to);
  if (filters.page) params.set('page', String(filters.page));
  if (filters.pageSize) params.set('pageSize', String(filters.pageSize));
  const qs = params.toString();
  const { data } = await api.get<AuditLogPage>(`/audit-logs${qs ? `?${qs}` : ''}`);
  return data;
}

export async function listAuditLogActions(): Promise<string[]> {
  const { data } = await api.get<string[]>('/audit-logs/actions');
  return data;
}

export async function listAuditLogActors(): Promise<AuditLogActor[]> {
  const { data } = await api.get<AuditLogActor[]>('/audit-logs/actors');
  return data;
}
